import React from "react";
import { useTranslation } from "react-i18next";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import * as Styled from "./goalComponents.styles";
import Link from "next/link";
import Image from "next/image";

interface SliderProps {
  idx: number;
  item: string;
  active: string;
  handleClick(item: string): void;
}

export const CardSlider = ({ idx, item, active, handleClick }: SliderProps) => {
  const { t } = useTranslation("global");
  const slideItems = [1, 2, 3, 4];
  return (
    <Styled.SlideBox key={idx} onClick={() => handleClick(item)}>
      <Styled.ImgCardContainer>
        <Styled.CustomImg small={true}>
          <Image
            src={`/assets/ourGoalsSmall/${item}.webp`}
            alt="ourGoal"
            fill
            quality={100}
            style={{
              objectFit: "cover",
            }}
          />
        </Styled.CustomImg>
        <Styled.CustomImg small={false}>
          <Image
            src={`/assets/ourGoalsLarge/${item}.webp`}
            alt="ourGoal"
            fill
            quality={100}
            style={{
              objectFit: "cover",
            }}
          />
        </Styled.CustomImg>
      </Styled.ImgCardContainer>

      <Styled.CardDetails active={active === item}>
        <Styled.HeaderBox>
          <h2 className="headline-medium weight-medium">{t(`ourGoalTitle.cards.${item}.title`)}</h2>
          {item === active ? <KeyboardArrowDownIcon color="secondary" /> : <KeyboardArrowUpIcon />}
        </Styled.HeaderBox>

        <Styled.Subtitle className="headline-medium">{t(`ourGoalTitle.cards.${item}.description`)}</Styled.Subtitle>

        <Styled.DescriptionCard className="body-small" active={active === item}>
          {t(`ourGoalTitle.cardOnHover.${item}.introduction`)}
        </Styled.DescriptionCard>
        {slideItems.map((hoverItem, i) => (
          <Styled.ItemBox key={i}>
            <Styled.IconImg src={t(`ourGoalTitle.cardOnHover.${item}.item${hoverItem}.icon${i + 1}`) as string} alt="ourGoal-icon" />
            <p className="body-medium">{t(`ourGoalTitle.cardOnHover.${item}.item${hoverItem}.title${i + 1}`)}</p>
          </Styled.ItemBox>
        ))}

        <Styled.Btn endIcon={<ArrowForwardIcon />} color="secondary" variant="text" size="large" fullWidth={false} className="body-medium">
          <Link href="/freetrial">{t(`ourGoalTitle.button`)}</Link>
        </Styled.Btn>
      </Styled.CardDetails>
    </Styled.SlideBox>
  );
};
